import React from "react";
import { ArrowRightIcon } from "lucide-react";
type CtaButtonProps = {
  href: string | null;
  children: React.ReactNode;
  size?: "lg" | "md";
  fullWidth?: boolean;
  disabledLabel?: string;
  onClick?: () => void;
};
export function CtaButton({
  href,
  children,
  size = "lg",
  fullWidth = false,
  disabledLabel,
  onClick
}: CtaButtonProps) {
  const sizing = size === "lg" ? "px-5 py-4 text-base sm:px-7 sm:text-lg md:px-8 md:py-5 md:text-[22px]" : "px-4 py-2.5 text-sm";
  const width = fullWidth ? "w-full" : "w-full sm:w-auto";
  if (!href) {
    return <button type="button" disabled className={`${sizing} ${width} inline-flex cursor-not-allowed items-center justify-center rounded-xl bg-[#DAE3F3] font-bold uppercase text-[#536680]`} data-id="element-99" data-mp="ljmnsenlqcx1">
        {disabledLabel ?? "Compra disponible próximamente"}
      </button>;
  }
  return <a href={href} onClick={onClick} className={`${sizing} ${width} inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-xl bg-cta font-bold uppercase text-white no-underline shadow-[0_6px_0_#164BBB] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-cta-hover active:translate-y-1 active:shadow-[0_2px_0_#164BBB]`} data-id="element-100" data-mp="159q5kgbd2z6y">
      {children}
      <ArrowRightIcon className={size === "lg" ? "h-5 w-5" : "h-4 w-4"} aria-hidden="true" data-id="element-101" data-mp="3jxgp2mclwcpr" />
    </a>;
}